import React from "react";

function Sidebar({ children, isSticky = false }) {
    return (
        <aside id="sidebar">
            <div className="holder" style={isSticky ? { position: "sticky", top: "0" } : undefined}>
                <div className="post-s">{children}</div>
            </div>
        </aside>
    );
}

export default Sidebar;
